export default "__VITE_ASSET__adb4000a__"